export const PRINTER_TYPE_QZ = 'QZ';
export const PRINTER_TYPE_CLOUDPRINT = 'cloudprint';
export const PRINTER_TYPE_WEBPRINT = 'WEBPRNT';
export const PRINTER_TYPE_EPSON = 'epson';
